// removed by extract-text-webpack-plugin
module.exports = {"jobs":"_1ixxj3uB","past-roles":"_2xYs9KMc","pastRoles":"_2xYs9KMc","past-role":"_3A3tBd1B","pastRole":"_3A3tBd1B","title":"_37w3-MME","date":"_3vxCJVJs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Jobs/Jobs.pcss
// module id = 1004
// module chunks = 0